import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import swal from 'sweetalert';
import Axios from 'axios';
import { useSelector, useDispatch } from "react-redux"
import * as Actions from "../../../store/actions"
import { VERSION_NO } from '../../../store/actions';
const EndingMeetingDialog = props => {

    const dispatch = useDispatch()

    const [Response, setResposnse] = useState("")
    const [Option, setOption] = useState("")
    const [Text, setText] = useState("")
    const [DontShowModal, setDontShowModal] = useState(false)

    const IsMobTab = window.innerWidth < 400 ? true : false; // true means tab and mob && false means desktop
    const baseURL = useSelector(({ utils }) => utils.baseURL);
    const meetingUserId = useSelector(({ meeting }) => meeting.meetingUserId)
    const LocalUserName = useSelector(({ meeting }) => meeting.LocalUserName)


    const isHost = useSelector(({ meeting }) => meeting.IsHost)


    useEffect(() => {
        if (props.isOpen) {
            const query2 = new URLSearchParams(location.search)

            if (query2.has("videosessionid")) {
                setDontShowModal(true)
                // setTimeout(() => {
                const roomNo = window.location.pathname.replace("/room/", "").substring(0, 9);

                console.log("MEETING ENDED FROM EndMeetingDialog 1")

                dispatch(Actions.MeetingStopped(roomNo, LocalUserName)).then(() => {

                    props.close()
                })

                // }, 2000);
                // if (isHost) {
                //     history.push("/room")
                // }
                // history.go()
            }
        }
    }, [props.isOpen])


    if (DontShowModal) {
        return <></>
    }
    return (
        <Modal
            isOpen={props.isOpen}
            toggle={() => props.close()}
            size="xl"

            centered
            contentClassName="EndMeetingDialog"

        >
            <ModalHeader style={{ border: "none", width: "100%" }} toggle={() => props.close()}></ModalHeader>
            <ModalBody style={{ height: "650px", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", overflow: "hidden" }}>
                <img id="logoclinicdynamic" src="/images/ptlogo.png" style={{ height: "50px", margin: "-50px 0 10px 0" }} />
                <h2 className="end-heading">
                    Your meeting has ended.
                </h2>
                <h2 className="end-heading">
                    How well did Somatic Telehealth perform?
                </h2>
                <h2 className="end-heading2">
                    Please rate the audio and video quality
                </h2>
                <div style={{ display: "flex", flexDirection: "column", width: IsMobTab ? "280px" : "340px" }}>
                    <span style={{ cursor: "pointer", color: Response === "Yes" ? "cornflowerblue" : "white" }} onClick={() => setResposnse("Yes")}>
                        <i className="fa fa-thumbs-up"></i> Positive
                    </span>
                    <span style={{ cursor: "pointer", color: Response === "No" ? "cornflowerblue" : "white" }} onClick={() => {
                        setResposnse("No")
                        setOption(5)
                    }}>
                        <i className="fa fa-thumbs-down"></i> Negative
                    </span>
                    {
                        Response === "No" ? (
                            <>
                                <div className="wrapper" style={{ marginLeft: IsMobTab ? "0px" : "20px", display: "flex" }}>
                                    <input type="radio" id="optn3" checked={Option === 1} onChange={() => setOption(1)} />
                                    <label style={{ marginLeft: "10px" }} className="label-check" htmlFor="optn3">Video drops during the video call.</label>
                                </div>
                                <div className="wrapper" style={{ marginLeft: IsMobTab ? "0px" : "20px", display: "flex" }}>
                                    <input type="radio" id="optn34" checked={Option === 2} onChange={() => setOption(2)} />
                                    <label style={{ marginLeft: "10px" }} className="label-check" htmlFor="optn34">Video freeze during the video call.</label>
                                </div>
                                <div className="wrapper" style={{ marginLeft: IsMobTab ? "0px" : "20px", display: "flex" }}>
                                    <input type="radio" id="optn6" checked={Option === 3} onChange={() => setOption(3)} />
                                    <label style={{ marginLeft: "10px" }} className="label-check" htmlFor="optn6">Can not hear other participant's voice.</label>
                                </div>
                                <div className="wrapper" style={{ marginLeft: IsMobTab ? "0px" : "20px", display: "flex" }}>
                                    <input type="radio" id="optn36" checked={Option === 4} onChange={() => setOption(4)} />
                                    <label style={{ marginLeft: "10px" }} className="label-check" htmlFor="optn36">Others can not hear my voice.</label>
                                </div>
                                <div className="wrapper" style={{ marginLeft: IsMobTab ? "0px" : "20px", display: "flex" }}>
                                    <input type="radio" id="optn3hi" checked={Option === 5} onChange={() => setOption(5)} />
                                    <label style={{ marginLeft: "10px" }} className="label-check" htmlFor="optn3hi">Others.</label>
                                </div>
                            </>
                        ) : null
                    }
                    <span>
                        <i className="fa fa-comment"></i> Leave Comment
                    </span>

                    <textarea
                        value={Text}
                        maxLength="400"
                        onChange={({ target }) => setText(target.value)}
                        className="textAreaInput"

                    />
                </div>
                <Button
                    onClick={async () => {
                        if (Response === "") {
                            swal("Please provide a review!", "", "error")
                        } else {
                            Axios.post(`${baseURL}/PT2/httpdocs/${VERSION_NO}/PostUserFeedback`, {
                                meetingUserId: meetingUserId,
                                feedback: Text,
                                negativetypelkp: Option,
                                isPositive: Response == "Yes" ? 1 : 0
                            })
                            swal("Thank you", "Your feedback has been saved!", "success").then(() => {

                                const roomNo = window.location.pathname.replace("/room/", "").substring(0, 9);
                                console.log("MEETING ENDED FROM EndMeetingDialog 2")

                                dispatch(Actions.MeetingStopped(roomNo, LocalUserName)).then(() => {

                                    props.close()
                                })
                            })
                        }
                    }}
                    color="warning"
                    style={{ marginTop: "20px", color: "white", borderRadius: "100px", height: "30px", width: "100px", marginLeft: "10px", paddingTop: 2, }}
                >
                    Submit
                </Button>
            </ModalBody>

        </Modal>
    )
}

EndingMeetingDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
}

export default EndingMeetingDialog
